<clx-form>
    <clx-row type="buttons">
        <clx-item>
            <clx-button type="save" i18n="@@third-party-app.register.button.register" test-id="third-party-app.register.button.register" (click)="register(appid.value)">Register</clx-button>
        </clx-item>
    </clx-row>

    <clx-row>
        <clx-label i18n="@@third-party-app.register.appid">App Id</clx-label>
        <clx-input test-id="third-party-app.register.appid" name="appid" #appid>
            <clx-validation type="uuid" [errorMessage]="validationMessage" format="844412"></clx-validation>
        </clx-input>
    </clx-row>
</clx-form>